<div class="filterOptionsRow">
  <mat-select
    [value]="sortMethod"
    (selectionChange)="onSortMethodChange.emit($event.value)"
    *hasRole="STAFF_AND_DASHBOARD_ROLES"
    [name]="sort"
  >
    <mat-option [value]="SORT_NAME">
      {{ "sort.name" | translate }}
    </mat-option>
    <mat-option [value]="SORT_LAST_ACTIVITY">
      {{ "sort.lastActivity" | translate }}
    </mat-option>
  </mat-select>

  <!-- Enabled will be displayed on the left, because of row-reverse -->
  @if (showEnabledToggle) {
    <ng-container *hasRole="CAN_VIEW_DISABLED">
      <mat-radio-group
        [value]="enabledOnly"
        (change)="onEnabledOnlyChange.emit($event.value)"
      >
        <mat-radio-button [value]="true">Active</mat-radio-button>
        <mat-radio-button [value]="false">Archived</mat-radio-button>
      </mat-radio-group>
    </ng-container>
  }
</div>
